const taipeiDateFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Taipei',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export type BookPublicationBadge = 'new' | 'upcoming' | null;

export function getTaipeiToday(now = new Date()): string {
  const parts = taipeiDateFormatter.formatToParts(now);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
}

export function getBookPublicationBadge(
  publishDate: string | null | undefined,
  now = new Date(),
): BookPublicationBadge {
  if (!publishDate || !/^\d{4}-\d{2}-\d{2}$/.test(publishDate)) return null;

  const parsedPublishDate = new Date(`${publishDate}T00:00:00.000Z`);
  if (
    !Number.isFinite(parsedPublishDate.getTime()) ||
    parsedPublishDate.toISOString().slice(0, 10) !== publishDate
  ) {
    return null;
  }

  const today = getTaipeiToday(now);
  if (publishDate > today) return 'upcoming';

  const newBookWindowStart = new Date(`${today}T00:00:00.000Z`);
  newBookWindowStart.setUTCDate(newBookWindowStart.getUTCDate() - 6);
  return publishDate >= newBookWindowStart.toISOString().slice(0, 10) ? 'new' : null;
}

export function getBookPublicationBadgeLabel(badge: Exclude<BookPublicationBadge, null>): string {
  return badge === 'new' ? '新書' : '即將發行';
}

export function getBookPublicationBadgeClass(badge: Exclude<BookPublicationBadge, null>): string {
  return badge === 'new'
    ? 'bg-accent-500 text-foreground-950'
    : 'bg-secondary-500 text-white';
}
